import { useLocation, useHistory } from 'react-router-dom';
import { CLIENT_PRODUCT } from '../../constants/products.js';

import * as ROUTES from '../../constants/routes.js';
import withLandingRedirect from 'components/OrgSelector/withLandingRedirect.jsx';

export const ProfileShortcut = withLandingRedirect(({ orgId }) => {
  const history = useHistory();
  const route = ROUTES.ORG_USER_PROFILE.replace(ROUTES.ONE_TO_ANY, orgId);

  history.replace(route);
  return null;
});

export const OrgShortcut = withLandingRedirect(({ orgId }) => {
  const history = useHistory();
  const location = useLocation();
  history.replace(`/${orgId}${location.pathname}`);
  return null;
});

export const ClientShortcut = withLandingRedirect(({ clientId }) => {
  const history = useHistory();
  const location = useLocation();
  history.replace(`/${CLIENT_PRODUCT}/${clientId}${location.pathname}`);
  return null;
});
